import * as React from "react";
import {BuildingsTable} from "../common/buildings-table/buildings-table";

export const NormalView = BuildingsTable;
